<template>
    <div id="customer-manage">
        <h3 class="text-primary text-center mb-2">DANH SÁCH KHÁCH HÀNG TƯ VẤN</h3>
        <div class="vx-card px-6 py-2">
            <vs-table class="table-custom" :data="consultingData" noDataText="Không có dữ liệu">
                <template slot="thead">
                    <vs-th>
                        STT
                    </vs-th>
                    <vs-th style="min-width: 200px">
                        <div>
                            <label class="vs-input--label">Phân loại khách hàng</label>
                            <v-select v-model="selectedCustomerTypeValue" :options="customerTypeOptions"
                                name="customerType" :clearable="false" :reduce="item => item.value" style="width: 200px"
                                @input="filter">
                            </v-select>
                        </div>
                    </vs-th>

                    <vs-th style="min-width: 200px">
                        <div class="w-full">
                            <label>Cơ sở</label>
                            <v-select v-model="organizationBranchId" :options="branchOptions" :clearable="false" :reduce="item => item.value"
                                style="min-width: 200px" @input="filter" >
                            </v-select>
                        </div>
                    </vs-th> <vs-th style="min-width: 200px">
                        <div class="w-full">
                            <label>Nguồn khách</label>
                            <v-select v-model="sourceValue" :options="sourceOptions" :clearable="false" @input="filter"
                                :reduce="option => option.value" style="min-width: 200px">
                                <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                            </v-select>
                        </div>
                    </vs-th>
                    <vs-th style="min-width: 200px">
                        <div class="w-full">
                            <label>Ngày tư vấn</label>
                            <date-range-picker ref="picker" :locale-data="{ format: 'dd/mm/yyyy' }" :opens="'right'"
                                @update="dateRangePicker" v-model="dateRange" class="w-full" style="min-width:200px" @input="filter">
                            </date-range-picker>
                        </div>
                    </vs-th>
                    <vs-th style="min-width: 200px">
                        <div class="w-full">
                            <label>Mảng dịch vụ</label>
                            <vs-input v-model="beautyGroupServiceName" @keyup.enter="filter"/>
                        </div>
                    </vs-th>
                    <vs-th style="min-width: 200px">
                        <div class="w-full">
                            <label>Nhóm dịch vụ</label>
                            <vs-input v-model="beautyServicePackageName" @keyup.enter="filter"/>
                        </div>
                    </vs-th>
                    <vs-th style="min-width: 200px">
                        <div>
                            <label class="vs-input--label">Tên Khách Hàng</label>
                            <v-select v-model="selectedCustomerValue" :options="customerNameOption"
                                :reduce="item => item.value" name="branch" :clearable="false" style="width: 200px;"
                                @input="filter">
                                <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                            </v-select>
                        </div>
                    </vs-th>
                    <vs-th style="min-width: 200px">
                        <div>
                            <label class="vs-input--label">Giới tính</label>
                            <v-select class="relative" style="min-width: 200px" v-model="gender"
                                :options="genderOptions" :reduce="item => item.value" :clearable="false"
                                @input="getConsultingData"></v-select>
                        </div>
                    </vs-th>
                    <vs-th style="width: 200px" class="">
                        <div>
                            <label class="vs-input--label">Số điện thoại</label>
                            <vs-input v-model="phoneNumber" @keyup.enter="getConsultingData"></vs-input>
                        </div>
                    </vs-th>
                    <vs-th style="min-width: 200px">
                        <div class="w-full">
                            <label>Người tư vấn</label>
                            <vs-input ></vs-input>
                        </div>
                    </vs-th>
                    <vs-th style="min-width: 200px">
                        <div>
                            <label class="vs-input--label">Trạng thái hồ sơ</label>
                            <v-select v-model="selectedStatusValue" :options="statusOptions" name="status"
                                :clearable="false" :reduce="item => item.value" style="width: 200px" @input="filter">
                                <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                            </v-select>
                        </div>
                    </vs-th>
                    <vs-th style="min-width: 200px">
                        <div class="w-full">
                            <label>Người tiếp nhận</label>
                            <vs-input ></vs-input>
                        </div>
                    </vs-th>
                    <vs-th style="width: 150px ">
                        <div style="width: 150px ">
                            <label class="vs-input--label">Hành động</label>
                        </div>
                    </vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                            {{ tr.stt }}
                        </vs-td>
                        <vs-td>
                            <CellRendererCustomerStatus :rowData="tr"></CellRendererCustomerStatus>
                        </vs-td>
                        <vs-td class="text-primary">
                            {{ tr.nameBranch }}
                        </vs-td>
                        <vs-td>
                            {{ checkSource(tr.loyaltyCustomer.sourceType) }}
                        </vs-td>
                        <vs-td>
                            {{ tr.createdDateCvt }}
                        </vs-td>
                        <vs-td class="text-primary">
                            {{
                                tr.beautyMedicalReports.length > 0 && tr.beautyMedicalReports[0].beautyGroupService ?
                                    tr.beautyMedicalReports[0].beautyGroupService.name : null
                            }}
                        </vs-td>
                        <vs-td class="text-primary">
                            {{ tr.beautyMedicalReports.length > 0 &&
                                tr.beautyMedicalReports[0].beautyMedicalReportDetails.length > 0 &&
                                tr.beautyMedicalReports[0].beautyMedicalReportDetails[0].beautyService ?
                                tr.beautyMedicalReports[0].beautyMedicalReportDetails[0].beautyService.name : null }}
                        </vs-td>
                        <vs-td class="over-text text-primary">
                            {{ tr.customerName }}
                        </vs-td>
                        <vs-td class="over-text">
                            {{ tr.genderStr }}
                        </vs-td>
                        <vs-td class="over-text">
                            {{ tr.phoneNumberCvt }}
                        </vs-td>
                        <vs-td>
                        </vs-td>

                        <vs-td>
                            <vs-chip class="ag-grid-cell-chip-customer"
                                :color="chipColorSeen(tr.settingMedicalExaminationStep.medicalExaminationStep.name)">
                                {{ tr.settingMedicalExaminationStep.medicalExaminationStep.name }}
                            </vs-chip>

                        </vs-td>
                        <vs-td>
                        </vs-td>
                        <vs-td>
                            <CellRendererActionsConsulting :rowData="tr"></CellRendererActionsConsulting>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>

            <div class="vx-row" v-if="consultingData.length > 0">
                <div class="vx-col md:w-1/2">
                    <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                        <span class="vx-col mt-2">Số phần tử / trang:</span>
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div
                                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                <span class="mr-2">
                                    {{
                                        consultingData.length - currentPage * pageSize > 0 ? currentPage *
                                            pageSize
                                            : consultingData.length
                                    }} /
                                    {{ totalElements }}</span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item @click="changePageSize(20)">
                                    <span>20</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(30)">
                                    <span>30</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(50)">
                                    <span>50</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(100)">
                                    <span>100</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                    <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage" />
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import vSelect from 'vue-select';
import DateRangePicker from '../../../../components/vue2-daterange-picker/components/DateRangePicker.vue';
import { AgGridVue } from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
// import Pagination from "../../ui-elements/Pagination.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus";
import CellRendererActionsConsulting from "./cell-renderer/CellRendererActionsConsulting";
import CellRendererCustomerStatus from "./cell-renderer/CellRendererCustomerStatus";
import moment from "moment";
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ModuleRegistry } from '@ag-grid-community/core';
import { en, vi } from "vuejs-datepicker/dist/locale";
import Datepicker from 'vuejs-datepicker';

ModuleRegistry.registerModules([ClientSideRowModelModule]);

export default {
    components: {
        vSelect,
        DateRangePicker,
        AgGridVue,
        CellRendererStatus,
        CellRendererActionsConsulting,
        CellRendererCustomerStatus,
        Datepicker
    },

    data() {
        return {
            branchOptions: [],
            selectedBranchValue: null,
            parentId: null,

            // AgGrid
            gridApi: null,
            gridOptions: {},
            pageNumber: 0,
            pageSize: 50,
            totalPages: 0,
            currentPage: 1,
            totalElements: 0,
            dateRange: {
                endDate: new Date(new Date().setHours(23, 59, 59, 999)),
                startDate: new Date(new Date().setDate(new Date().getDate() - 7)).setHours(0, 0, 0, 0),
            },
            highlightedFn: {
                customPredictor(date) {
                    if (moment(new Date()).format('YYYY-MM-DD') == moment(new Date(date)).format('YYYY-MM-DD')) {
                        return true;
                    }
                }
            },
            disabledDates: {
                customPredictor(date) {
                    if (moment(date).isAfter(moment(), 'days')) {
                        return true;
                    }
                }
            },

            vi: vi,
            en: en,
            customerTypeOptions: [
                { value: null, label: "Tất cả" },
                { value: 1, label: "Khách hàng cũ tới tái khám" },
                { value: 2, label: "Khách hàng cũ sử dụng dịch vụ" },
                { value: 3, label: "Khách hàng cũ tới tư vấn dv" },
                { value: 4, label: "Khách hàng mới đến tư vấn" },
                { value: 5, label: "Khách hàng tới mua thuốc mỹ phẩm" },
                { value: 6, label: "Khách hàng trả lại thuốc" },
                { value: 7, label: "Khách hàng tới hoàn phí" },
            ],
            sourceOptions: [
                { value: null, label: 'Tất cả' },
                { value: 1, label: 'Phòng kinh doanh 1' },
                { value: 2, label: 'Phòng kinh doanh 2' },
                { value: 3, label: 'Nhân viên' },
                { value: 4, label: 'Phòng kinh doanh 3' },
                { value: 5, label: 'Phòng kinh doanh 4' },
                { value: 6, label: 'Nguồn khác' },
                { value: 7, label: 'Nguồn App' },
            ],
            genderOptions: [
                { value: null, label: 'Tất cả' },
                { value: 0, label: this.$t('genderOption.unknown') },
                { value: 1, label: this.$t('genderOption.male') },
                { value: 2, label: this.$t('genderOption.female') }
            ],
            selectedCustomerTypeValue: null,
            consultingData: [],
            customerOptions: [],
            customerNameOption: [{ value: null, label: "Tất cả" }],

            selectedCustomerValue: null,
            pageNumberSelectCustomer: 0,
            pageSizeSelectCustomer: 20,
            statusOptions: [],
            selectedStatusValue: 'null',
            observer: null,
            limit: 20,
            search: '',
            typingSearchCustomer: null,
            textTypingSearch: null,
            showListCustomer: false,
            nanoCustomerCode: null,
            gender: null,
            phoneNumber: null,
            sourceValue: null,
            organizationBranchId:null,
            beautyGroupServiceName:null,
            beautyServicePackageName:null,
        }
    },

    computed: {
        selectedBranch: {
            get() {
                return {
                    label: this.getLabelString(this.branchOptions.find(x => x.value == this.selectedBranchValue)),
                    value: this.branchOptions.find(x => x.value == this.selectedBranchValue)
                }
            },
            set(obj) {
                this.selectedBranchValue = obj ? obj.value : null;
            }
        },

        filtered() {
            return this.customerOptions;
        },
        paginated() {
            return this.filtered.slice(0, this.limit);
        },
        chipColorSeen() {
            return value => {
                if (value === 'Thu phí') {
                    return "danger";
                }
                if (value === 'Hoàn tất') {
                    return "success";
                }
                if (value === 'Tư vấn') {
                    return "primary";
                }
                if (value === 'Tiếp đón') {
                    return "primary";
                }
                if (value === 'Cận lâm sàng') {
                    return "warning";
                }

            }
        },
        checkSource(){
            return value => {
                if (value === 1){
                    return "Kinh doanh 1"
                }
                if (value === 2){
                    return "Kinh doanh 2"
                }
                if (value === 3){
                    return "Nhân viên"
                }
                if (value === 4){
                    return "Nguồn khác"
                }
                if (value === 5){
                    return "Nguồn APP"
                }
                if (value === 6){
                    return "Kinh doanh 3"
                }
                if (value === 7){
                    return "Kinh doanh 4"
                }
            }
        }
    },

    async created() {

        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return { label: x.organizationBranchName, value: x.id }
        });
        this.branchOptions.unshift({ value: null, label: 'Tất cả' });

        await this.getParentId();
        this.getConsultingData()
        this.getCustomer();
    },

    watch: {
        '$store.state.windowWidth'(val) {
            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.deleteBeautyBooking'(val) {
            if (val) {
                this.getConsultingData();
                this.$store.commit('DELETE_BEAUTY_BOOKING', false);
            }
        },
        '$store.state.isUpdateFile'(val) {
            if (val) {
                this.filter();
                this.$store.commit('UPDATE_FILE_SUCCESS', false);
            }
        },
        dateRange(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.filter(); 
      }
    },
    },

    methods: {
        filter() {
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getConsultingData();
        },

        getLabelString(object) {
            return (object && object.label) || 'Chưa xác định';
        },
        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59, 999));
        },

        onGridReady() {
            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },

        loadPage: function (currentPage) {
            if (this.pageNumber !== parseInt(currentPage) - 1) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getConsultingData();
            }
        },

        changePageSize(number) {
            this.pageSize = number;
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getConsultingData();
        },

        getParentId() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();

                this.$crm.post('/setting-medical-examination-step/find-by-condition', { isGetParent: true }).then(res => {
                    if (res.data.content && res.data.content.length > 0) {
                        this.parentId = res.data.content[1].medicalExaminationStep.id;
                        this.statusOptions = res.data.content[1].listChildren.map(el => {
                            return {
                                value: el.id,
                                label: el.medicalExaminationStep.name,
                            }
                        })
                        this.statusOptions.unshift({ value: 'null', label: 'Tất cả' })
                    }
                    this.$vs.loading.close();
                    resolve(res)
                }).catch(err => {
                    reject(err);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getConsultingData() {
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
            let payload = {
                customerType: this.selectedCustomerTypeValue, //Phân lọai khách hàng
                endDate: this.dateRange.endDate,  //ngày tạo
                loyaltyCustomerId: JSON.parse(this.selectedCustomerValue),
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                startDate: this.dateRange.startDate,  //ngày tạo
                settingMedicalExaminationStepParentId: this.parentId, //id trạng thái
                settingMedicalExaminationStepId: JSON.parse(this.selectedStatusValue),
                nanoCustomerCode: this.nanoCustomerCode ? this.nanoCustomerCode : null,
                gender: this.gender,
                phoneNumber: this.phoneNumber ? this.phoneNumber : null,
                organizationBranchId:this.organizationBranchId,
                sourceType:this.sourceValue,
                beautyGroupServiceName:this.beautyGroupServiceName ? this.beautyGroupServiceName : null,
                beautyServiceName:this.beautyServicePackageName ? this.beautyServicePackageName : null,
            }
            // const payloads ={}
            // if (this.nanoCustomerCode) payloads['nanoCustomerCode'] = this.nanoCustomerCode;
            // const params = new URLSearchParams(payloads).toString();
            this.consultingData = [];

            this.$vs.loading();
            this.$crm.post('/beauty-medical-record/find-by-condition', payload).then(res => {
                if (res.data.content && res.data.content.length > 0) {
                    this.consultingData = res.data.content.map(el => {
                        el.stt = this.pageNumber * this.pageSize + res.data.content.indexOf(el) + 1;
                        el.customerName = el.loyaltyCustomer.fullName;
                        el.nanoCustomerCode = el.loyaltyCustomer.nanoCustomerCode;
                        el.phoneNumberCvt = el.loyaltyCustomer.phoneNumber ? this.convertPhone(el.loyaltyCustomer.phoneNumber) : null;
                        el.birthdayStr = el.loyaltyCustomer.birthday ? moment(el.loyaltyCustomer.birthday).format('DD/MM/YYYY') : el.loyaltyCustomer.birthDayRaw;
                        el.createdDateCvt = el.dateAdmission? moment(el.dateAdmission).format('DD/MM/YYYY') : null;
                        el.genderStr = el.loyaltyCustomer.gender === 0 ? this.$t('genderOption.unknown') : el.loyaltyCustomer.gender === 1 ? this.$t('genderOption.male') : el.loyaltyCustomer.gender === 2 ? this.$t('genderOption.female') : null;
                        el.countMedicalReportCompleted = el.countMedicalReportCompleted ? el.countMedicalReportCompleted : 0;
                        el.countMedicalReportNotCompleted = el.countMedicalReportNotCompleted ? el.countMedicalReportNotCompleted : 0;
                        if (branchList.length > 0) {
                            branchList.forEach(x => {
                                if (x.id == el.organizationBranchId) {
                                    el.nameBranch = x.organizationBranchName
                                    return
                                }
                            })
                        }
                        return el;
                    })
                }
                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        getCustomer() {
            let url = '/loyalty/customer/find'
            if (this.textTypingSearch != this.search) {
                this.textTypingSearch = this.search;
                this.customerOptions = [
                    { value: 'null', label: 'Tất cả' }
                ];
            }
            url += `?pageNumber=${this.pageNumberSelectCustomer}&pageSize=${this.pageSizeSelectCustomer}`;
            if (this.textTypingSearch) url += `&keySearch=${this.textTypingSearch}`;
            this.$vs.loading();
            this.$crm.get(url).then(res => {
                if (res.data.content && res.data.content.length > 0) {
                    let customer = res.data.content.map(el => {
                        return {
                            value: el.id,
                            label: el.phoneNumber + ' - ' + el.fullName
                        }
                    });
                    this.customerNameOption = res.data.content.map(el => {
                        return {
                            value: el.id,
                            label: el.fullName
                        }
                    });
                    this.customerNameOption.unshift({ value: null, label: 'Tất cả' });
                    this.customerOptions.push(...customer);
                }
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        convertPhone(phone) {
            let arrPhone = phone.split('');
            arrPhone[4] = '*';
            arrPhone[5] = '*';
            arrPhone[6] = '*';
            return arrPhone.join().replaceAll(',', '');
        },

        async onOpen() {
            this.showListCustomer = true;
            await this.$nextTick()
            this.observer.observe(this.$refs.load)
        },
        onClose() {
            this.search = '';
            this.pageNumberSelectCustomer = -1;
            this.showListCustomer = false;
            this.observer.disconnect()
        },
        async infiniteScroll([{ isIntersecting, target }]) {
            if (isIntersecting) {
                const ul = target.offsetParent;
                const scrollTop = target.offsetParent.scrollTop;
                this.limit += 20;
                this.pageNumberSelectCustomer += 1;
                await this.$nextTick();
                ul.scrollTop = scrollTop;
                this.getCustomer();
            }
        },

        searchCustomer(query) {
            if (this.showListCustomer) {
                if (this.search != query) this.pageNumberSelectCustomer = 0;
                this.search = query;
                clearTimeout(this.typingSearchCustomer);
                this.typingSearchCustomer = setTimeout(this.doneTypingSearch, 1500);
            }
        },

        async doneTypingSearch() {
            await this.getCustomer();
            if (this.customerOptions.length === 1) this.selectedCustomerValue = 'null';
            await this.onOpen();
        },
    },

    mounted() {
        this.gridApi = this.gridOptions.api;
        this.observer = new IntersectionObserver(this.infiniteScroll);
    },
}
</script>

<style>
@media (min-width: 1200px) {
    [dir] .main-horizontal.navbar-sticky .router-content {
        margin-top: 4rem !important;
    }
}
.vs--single .vs__selected {
    /* max-width: 160px !important; */
    /* min-width: 150px !important; */
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.table-custom .vs-table--tbody {
    min-height: 300px;
}
</style>
